import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Loginpage from "./LoginPage";
import Browse from "./Browse";
import GPTsearchPage from "./GPTsearchPage";




const Body = () => {
  


  const router = createBrowserRouter([
    {
      path: "/",
      element: <Loginpage />,
    },
    {
      path: "/browse",
      element: <Browse />,
    },
    {
      path: "/gptsearch",
      element: <GPTsearchPage />,
    },
    
  ]);
  ;
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};
export default Body;
